import React, { useState } from 'react';
import AntCoin from './images/AntCoin.png';
import AntFood from './images/AntFood.png';
import ActivityImg from './images/FoodGathering.png';
import useSolanaWeb3 from '../hooks/useSolanaWeb3.js';

function Gathering({ goBack }) {
  const { gatheringStake, gatheringUnStake } = useSolanaWeb3();
  const [value, setValue] = useState(0);
  const { antCoinBalance } = useSolanaWeb3();
  const [selectedPool, setSelectedPool] = useState(null);

  const handleInputChange = (event) => {
    setValue(event.target.value);
  };

  const handlePoolClick = (pool) => {
    setSelectedPool(pool);
  };

  const pools = [
    { id: 1, apy: '12.94%', stake: '90,000', rewards: '300', antCoin: '$ANTC', antFood: '$ANTF' },
    { id: 2, apy: '22.74%', stake: '90,000', rewards: '300', antCoin: '$ANTC', antFood: '$ANTF' },
    { id: 3, apy: '4.74%', stake: '90,000', rewards: '300', antCoin: '$ANTC', antFood: '$ANTF' },
    { id: 4, apy: '73.74%', stake: '90,000', rewards: '300', antCoin: '$ANTC', antFood: '$ANTF' },
  ];

  return (
    <section id="nestwars">
      <div className="newui-container">
        <div className="platform-container">
          <div className="inventory-container">
            <div className="inventory-container-left">
              <div className="treasury-container-left-top">
                <h2>GATHERING POOLS</h2>
              </div>
              <div className="gathering-filter-container">
                <div className="gathering-inside-container"><h2>STAKE</h2></div>
                <div className="gathering-inside-container"><h2>EARN</h2></div>
                <div className="gathering-inside-container2"><h2>APY</h2></div>
              </div>
              <div className="gathering-pools-container">
                {pools.map(pool => (
                  <div 
                    key={pool.id} 
                    className={`gathering-pool-container-full ${selectedPool?.id === pool.id ? 'active-gatheringasset' : ''}`} 
                    onClick={() => handlePoolClick(pool)}
                  >
                    <div className="gathering-pool-container-full-full">
                      <div className="gathering-pool-container">
                        <div className="gathering-inside-container">
                          <img src={AntCoin} alt="Ant Coin"/>
                          <div className="gathering-inside-text-container">
                            <h2>ANT COIN</h2>
                            <p>$ANTC</p>
                          </div>
                        </div>
                        <div className="gathering-inside-container">
                          <img src={AntFood} alt="Ant Food"/>
                          <div className="gathering-inside-text-container">
                            <h2>ANT FOOD</h2>
                            <p>$ANTF</p>
                          </div>
                        </div>
                        <div className="gathering-inside-container2">
                          <h2>{pool.apy}</h2>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="inventory-container-right">
              {selectedPool ? (
                <div className="pool-metrics">
                  <div className="left-content-incubating">
                    <h1>POOL METRICS</h1>
                    <p>Your Stake</p><h2>{selectedPool.stake}</h2><h2>{selectedPool.antCoin}</h2>
                    <p>Rewards</p><h2>{selectedPool.rewards}</h2><h2>{selectedPool.antFood}</h2>
                    <input
                      type="number"
                      value={value}
                      onChange={handleInputChange}
                      max={Math.min(antCoinBalance, 50000)}
                    />
                    <button onClick={() => gatheringStake(value)}>STAKE</button>
                    <button onClick={() => gatheringUnStake(value)}>UnSTAKE</button>
                  </div>
                </div>
              ) : (
                <div className="left-content-incubating">
                  <img src={ActivityImg} alt="Gathering"/>
                  <h1>GATHERING</h1>
                  <p>Stake tokens and earn rewards</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Gathering;